<script>
export default {
    name: "LinesInThePressTop"
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="198.148" height="363.129" viewBox="0 0 198.148 363.129">
        <g id="Group_1515" data-name="Group 1515" transform="translate(0.5 0.5)">
            <path id="Path_30" data-name="Path 30" d="M197.148,336.324V0L175.707,36.577,0,336.324V0" transform="translate(0 0)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1"/>
            <path id="Path_32" data-name="Path 32" d="M0,0V292.687" transform="translate(98.358 69.942)" fill="none" stroke="#fff" stroke-width="1"/>
            <path id="Path_34" data-name="Path 34" d="M0,336.323V0L21.441,36.577,197.148,336.323V0" transform="translate(0 0)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1"/>
        </g>
    </svg>
</template>
